import React from "react";
import { useGlobalState } from "../../../GlobalState";
import { Link, HashRouter as Router } from "react-router-dom";
import { AppView } from "../../views";
import { SimpleFooterPure, SimpleLoading } from "../../pures";
import {
  LocalStorageService,
  Auth0Service,
  ContractService,
  ClientService,
  BlogA3FirmaDigitalService,
  UserService,
  UpdateToken,
  NotificationSocketService,
  CacheStorageService,
  ModuleRoleService,
} from "../../../services";
import Routes from "../../../routes";
import { useTranslation } from "react-i18next";
import { ContextProvider, SocketContext, socket } from "../../../Context";
import PdfFullScreen from "../../../components/pures/signature-request-detail/pdf-full-screen";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import {
  DefaultUserImage
} from "../../../assets/logos/icons";
import { LogoeTicketHorizontal } from "../../../assets/logos";
import Ding from "../../../assets/sound/ding-ding-sound-effect.mp3";
import { MuiThemeProvider } from "@material-ui/core";
import { theme } from "../../../Theme";
import DialogCategory from "../../pures/dialog-category/dialog-category";
import Swal from 'sweetalert2'
import { ModalUtil } from '../../pures';

/**
 * @class AppAction
 * @extends {React.Component}
 * @status no delete
 * @description Defines the actions that the application takes.
 */
class AppAction extends React.Component {
  token = {};
  url = process.env.REACT_APP_ETICKET_API;
  urlBlog = process.env.REACT_APP_BLOG_MIFIRMA_URI;
  localStorageService = new LocalStorageService();
  auth0Service = new Auth0Service();
  contractService = new ContractService(this.url);
  clientService = new ClientService(this.url);
  blogA3FirmaDigitalService = new BlogA3FirmaDigitalService(this.urlBlog);
  moduleRoleService = new ModuleRoleService(this.url);
  userService = new UserService(process.env.REACT_APP_ETICKET_API);
  updateToken = new UpdateToken(process.env.REACT_APP_ETICKET_API);
  notificationSocketService = new NotificationSocketService(
    process.env.REACT_APP_ETICKET_API
  );

  state = {
    expanded: true,
    userType: {},
    selectedId: 0,
    tokenHasBeenUpdated: false,
    itemsReceived: [],
    userName: "",
    visibleDialogCreateDigitalSign: false,
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    waitingVerification: true,
    contract: true,
    verified: false,
    loading: true,
    showError: false,
    verifiedSignRequest: false,
    visibleDialogTimerSignOff: false,
    showClosingSession: false,
    intervalId: "",
    timeRemaining: "",
    userContinueAnyway: false,
    loadignMessage: "",
    logo: null,
    helpSection: "",
    helpSectionFirstsFaqs: [],
    helpSectionFirstVideo: "",
    helpSectionSelect: "",
    showHelpSection: false, //keep
    initializeHelpSection: false, //keep
    initializeProfileSection: false,
    initializeSettingSection: false,
    showNotification: false, // keep
    initializeNotification: false, //keep
    showProfileDropdown: false,
    showProfileSlideBar: false,
    showSettingSlideBar: false,
    highPriority: false,
    notification: [],
    notificationQuantity: 0,
    soundActive: true,
    lastPostImg: "",
    lastPostDate: "",
    lastPostTitle: "",
    lastPostDescription: "",
    lastPostSeeMore: "",
    titleFooter: this.props.t("promotionalFooterPure.titleContact"),
    userPathImage: "",
    matchMobileResolution: window.matchMedia("(max-width: 500px)").matches,
    botConfigList: []
  };

  items = []

  drawerProps = {
    position: "start",
    mode: "push",
    mini: true,
  };

  componentDidMount = async () => {
    let user = await this.localStorageService.getLocalStorageItem("user");
    this.token = await this.localStorageService.getLocalStorageItem("token")
      .idToken;
    let userEmail = user.userMetaData.userA3Cloud.email;
    let modules = await this.localStorageService.getLocalStorageItem("modules");
    this.token = await this.localStorageService.getLocalStorageItem("token")
      .idToken;

    let contract = await this.contractService.validateContractUser(this.token);
    let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
    let timezone = await this.localStorageService.getLocalStorageItem("timezone");

    socket.emit("onLogin", {
      email: userEmail,
      access_token: this.token,
      isMobile: true,
      timezone
    });

    socket.on("notifications", (data) => {
      // this.onUpdateSocket(data.data);
    });

    socket.on("notification", (data) => {
      console.log(data, 'notificacion individual')
      // this.onUpdateSocket(data.data);
    });

    let lastPostInfo = null;
    if (lastPostInfo !== null) {
      this.localStorageService.setLocalStorageItem(
        "lastPostInfo",
        lastPostInfo
      );
      this.localStorageService.setLocalStorageItem(
        "lastPostInfoImg",
        lastPostInfo.image
      );
      let blog = await this.localStorageService.getLocalStorageItem(
        "lastPostInfo"
      );
      let postDate = this.blogA3FirmaDigitalService.formatDateAndMonth(
        blog[0].date
      );
      this.localStorageService.setLocalStorageItem("postDate", postDate);
    }

    this.newImage = this.localStorageService.getLocalStorageItem("newImage");

    /* Gets Modules on left panel and then validates the routes alowed in modules of user session */
    let modulesOnLeftPanel = await this.moduleRoleService.getModulesOnLeftPanel(this.token)
    modulesOnLeftPanel.data.map(item => {
      return this.items.push({
        text: item.onLeftPanelJson.text,
        icon: item.icon,
        parentId: 1,
        route: item.path,
        toolTipText: item.onLeftPanelJson.tooltipText
      })
    })
    let itemsApplication = this.items;
    let itemsCurrent = [];

    for (let i = 0; i < itemsApplication.length; i++) {
      if (itemsApplication[i].hasOwnProperty("route") === true) {
        for (let j = 0; j < modules.length; j++) {
          if (itemsApplication[i].route === modules[j].path) {
            if (modules[j].path === "/close-session") {
              continue;
            } else {
              itemsCurrent.push({
                icon: modules[j].icon,
                route: modules[j].path,
                text: itemsApplication[i].text,
                selected: itemsApplication[i].selected,
                tooltipText: itemsApplication[i].tooltipText,
                target: itemsApplication[i].target,
                parentId: itemsApplication[i].parentId,
              });
              break;
            }
          }
        }
      } else {
        itemsCurrent.push(itemsApplication[i]);
      }
    }

    /* Fill User, Contract and Modules validated information in state */
    let userType = user.userMetaData.userA3Cloud
      ? user.userMetaData.userA3Cloud.userType
      : {};
    window.location.hash = "";
    let intervalId = setInterval(this.onSignOffByTimerEnd, 1000);

    let userInformation = user.userMetaData.userA3Cloud;
    let image;
    this.newImage
      ? (image = this.newImage)
      : userInformation.profilePicture
        ? (image = userInformation.profilePicture)
        : (image = user.userMetaData.userAuth0.picture);

    let pathImage = `${image}`;

    const handler = (e) => this.setState({ matchMobileResolution: e.matches });
    window.matchMedia("(max-width: 500px)").addEventListener("change", handler);

    await this.setState({
      userType,
      itemsReceived: itemsCurrent,
      userName: `${user.userMetaData.userA3Cloud.firstName} ${user.userMetaData.userA3Cloud.firstLastName}`,
      loading: false,
      contract,
      intervalId,
      logo,
      userPathImage: pathImage === "undefined" ? DefaultUserImage : pathImage
    });
  };

  /**
   * @author Alan Aguilar
   * @description componentDidMoun to update the component App
   * @updatedDate 11-05-2021
   * @status no delete
   * @memberof AppAction
   */
  componentWillUnmount = async () => {
    clearInterval(this.state.intervalId);
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @date 22-10-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the complete request dialog modal
   * @date 22-10-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (redirect === true) window.location.reload();
        }, 3000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the Error request dialog modal
   * @date 22-10-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 3000);
      }
    );
  };

  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  handleClick = (event) => {
    this.setState({ selectedId: 0 });
    let myStorage = window.localStorage;
    const tabSelected = {
      buttonFilterSelectedBlue: "table-button-blue-active",
      buttonFilterSelectedGreen: "",
      buttonFilterSelectedRed: "",
      buttonFilterSelectedOrange: "",
      buttonFilterSelectedGray: "",
    };
    myStorage.setItem("tabSelected", JSON.stringify(tabSelected));
    window.location.hash = "";
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the closing session dialog modal
   * @updatedDate 11-05-2020
   * @status no delete
   * @memberof AppAction
   */
  toggleClosingSession = (value) => {
    this.setState({
      showClosingSession: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show and hide the Timer to close sesion
   * @updatedDate 11-05-2020
   * @status no delete
   * @memberof AppAction
   */
  toggleDialogTimerSignOff = () => {
    this.setState({
      visibleDialogTimerSignOff: !this.state.visibleDialogTimerSignOff,
      userContinueAnyway: true,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show and hide the Drawer Help Section
   * @updatedDate 09-09-2021
   * @status no delete
   * @memberof AppAction
   */
  toggleHelpSection = () => {
    this.setState(
      {
        initializeHelpSection: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showHelpSection: !this.state.showHelpSection,
            showNotification: false,
          });
        }, 100);
      }
    );
  };

  /**
   * @author Adrian Montemayor
   * @description Method to show and hide the Drawer Notification Section
   * @updatedDate 02-01-2023
   * @status no delete
   * @memberof AppAction
   */
  toggleNotification = () => {
    this.setState(
      {
        initializeNotification: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showNotification: !this.state.showNotification,
            // showHelpSection: false,
            showProfileSlideBar: false,
            showSettingSlideBar: false

          });
        }, 100);
      }
    );
  };

  /**
 * @author Adrian Montemayor
 * @description Method to show and hide the Drawer Notification Section
 * @updatedDate 02-01-2023
 * @status no delete
 * @memberof AppAction
 */
  toggleProfileSlideBar = (open) => {
    this.setState(
      {
        initializeProfileSection: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showProfileSlideBar: !this.state.showProfileSlideBar,
            showNotification: false,
            showSettingSlideBar: false,

          });
        }, 100);
      }
    );
  };

  /**
* @author Adrian Montemayor
* @description Method to show and hide the Drawer Notification Section
* @updatedDate 02-01-2023
* @status no delete
* @memberof AppAction
*/
  toggleSettingSlideBar = () => {
    this.setState(
      {
        initializeSettingSection: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showSettingSlideBar: !this.state.showSettingSlideBar,
            showNotification: false,
            showProfileSlideBar: false,

          });
        }, 100);
      }
    );
  };

  onUpdateSocket = async (notificationSocket) => {
    console.log(notificationSocket)
    // this.setState({
    //   highPriority: notificationSocket.highPriority,
    //   notification: notificationSocket.notification,
    //   notificationQuantity: notificationSocket.notificationQuantity,
    // });
  };


  /**
   * @author Adrian Montemayor
   * @description Method to mute or unmute
   * @updatedDate 02-01-2023
   * @status no delete
   * @memberof AppAction
   */
  toggleSoundActive = () => {
    this.setState({
      soundActive: !this.state.soundActive,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to close sesion if the user accept
   * @updatedDate 18-05-2020
   * @status no delete
   * @memberof AppAction
   */
  onSignOffByTimerEnd = () => {
    let timeSessionLS =
      this.localStorageService.getLocalStorageItem("timeSession");
    let sessionEnds =
      timeSessionLS && timeSessionLS.timeSessionEnd
        ? timeSessionLS.timeSessionEnd
        : "";

    let timeSessionEnd = new Date(sessionEnds);
    let timeSessionCurrent = new Date();

    let msTimeEnd = timeSessionEnd.getTime();
    let msTimeCurrent = timeSessionCurrent.getTime();
    let msDif = msTimeEnd - msTimeCurrent;
    let dif = msDif / 1000;
    let timeRemaining = Math.ceil(Math.abs(dif));
    if (timeSessionCurrent >= timeSessionEnd || timeRemaining <= 0) {
      this.onSignOffByUser();
      return true;
    }
    if (timeRemaining <= 60 && this.state.userContinueAnyway === false) {
      this.setState({
        visibleDialogTimerSignOff: true,
      });
    }
    if (this.state.visibleDialogTimerSignOff) {
      this.setState({ timeRemaining });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to refresh the user sesion token
   * @updatedDate 26-08-2021
   * @status no delete
   * @memberof AppAction
   */
  onRefreshUserToken = async () => {
    try {
      await this.toggleLoadingRequesting(true);

      this.setState({
        visibleDialogTimerSignOff: false,
        userContinueAnyway: true,
      });
      let user = await this.localStorageService.getLocalStorageItem("user");
      let userEmail = user.userMetaData.userA3Cloud.email;

      let update_token = await this.updateToken.updateToken(
        userEmail,
        this.token
      );
      await this.localStorageService.setLocalStorageItem(
        "token",
        update_token.data.data
      );
      this.token = await this.localStorageService.getLocalStorageItem("token");

      await this.localStorageService.timerSession(this.token);
      this.token = await this.localStorageService.getLocalStorageItem("token")
        .idToken;

      setTimeout(async () => {
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true, false);
      }, 2000);
    } catch (error) {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to close sesion if the user accept
   * @updatedDate 26-08-2021
   * @status no delete
   * @memberof AppAction
   */
  onSignOffByUser = async () => {
    try {
      await this.toggleClosingSession(true);
      this.setState({
        visibleDialogTimerSignOff: false,
        loadignMessage: "Cerrando sesión...",
      });
      await this.toggleLoadingRequesting(true);

      setTimeout(async () => {
        let logo = await this.localStorageService.getLocalStorageItem(
          "clientLogo"
        );
        await this.localStorageService.clearLocalStorage();
        await this.localStorageService.setLocalStorageItem("clientLogo", logo);
        await this.toggleLoadingRequesting(false);
      }, 2000);
    } catch (error) {
      return false;
    }
  };

  /**
   * @description logout button functionality
   * @status no delete
   * @memberof AppAction
   */
  handleButtonLogOut = async () => {
    try {
      // 1. Clear cache
      const cacheStorageService = new CacheStorageService()
      await cacheStorageService.clearCache()

      // 2. Disconnect sockets (if used)
      // this.notificationSocketService.disconnect()

      // 3. Log out from Auth0 (if used)
      await this.auth0Service.logout()

      // 4. Special handling for the logo (if necessary)
      let logo = await this.localStorageService.getLocalStorageItem("clientLogo")
      await this.localStorageService.clearLocalStorage()
      await this.localStorageService.setLocalStorageItem(
        "clientLogo",
        logo ? logo : ""
      )

      // 5. Full redirection
      window.location.href = '/'
    } catch (error) {
      console.error("Logout error:", error)
      window.location.reload() // Fallback
    }
  }

  /**
   * @param {*} event
   * @memberof AppAction
   */
  setSelectedItem = (event) => {
    this.setState({ selectedId: 0 });
    let myStorage = window.localStorage;
    const tabSelected = {
      buttonFilterSelectedBlue: "table-button-blue-active",
      buttonFilterSelectedGreen: "",
      buttonFilterSelectedRed: "",
      buttonFilterSelectedOrange: "",
      buttonFilterSelectedGray: "",
    };
    myStorage.setItem("tabSelected", JSON.stringify(tabSelected));
    window.location.hash = "";
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to change of page in the Drawer component
   * @updatedDate 05-05-2021
   * @status no delete
   * @memberof AppAction
   */
  onSelect = (event, history) => {
    let userCanAccessRoute;
    let { route } = event.itemTarget.props;
    let { contractExist, userHadContracts, contractsStatus } =
      this.state.contract.data;

    // If user has an active and aprove contract (common login)
    {/* Note that currently, all users can access all modules equally, so there is no difference in the admin and the user. */ }
    if (
      contractExist === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
    ) {
      userCanAccessRoute = true;

      // If user does not has a contract or is disble but had a contract aprovated proviously
    } else if (
      contractExist === false &&
      userHadContracts === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;

      // If the user contract exist and hab contrasct prevously but is pending to aprove
    } else if (
      contractExist === true &&
      userHadContracts === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
    ) {
      userCanAccessRoute =
        route === "/sign-request" || route === "/configuration" ? false : true;

      // If user has a contract expired and had a contract proviously but are expired or rejected
    } else if (
      contractExist === true &&
      userHadContracts === true &&
      (contractsStatus ===
        Number(process.env.REACT_APP_USER_CONTRACT_STATUS_EXPIRED) ||
        contractsStatus ===
        Number(process.env.REACT_APP_USER_CONTRACT_STATUS_REJECTED))
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;

      // If the user does not has a contract but is a user Invited
    } else if (
      contractExist === false
      // &&
      // this.state.userType.id ===
      // Number(process.env.REACT_APP_USER_TYPE_INVITADO)
    ) {
      userCanAccessRoute =
        route === "/sign-request" || route === "/configuration" ? false : true;

      // If the user does not has a contract but is a user Collaborator
    } else if (
      contractExist === false
      // &&
      // this.state.userType.id ===
      // Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;
    }

    if (userCanAccessRoute === true) {
      this.setState({ selectedId: event.itemIndex });
      history.push(event.itemTarget.props.route);
    }
  };

  setSelectedItem = (pathName) => {
    let currentPath = this.items.find((item) => item.route === pathName);
    if (currentPath) {
      return currentPath.text;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to check if the seletec menu option is access by contract user
   * @updatedDate 05-05-2021
   * @status no delete
   * @memberof AppAction
   */
  checkForAuthorization = (history) => {
    let { contract, verified } = this.state;
    if (
      contract.data.contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING) &&
      !verified
    ) {
      this.setState({ verified: true });
      history.push("/waiting-authorization");
    }
  };

  /**
   * @author Adrian Montemayor
   * @description Handler method to redirect an user if he is accessing from a "Sign Request Email"
   * @updatedDate 10-05-2021
   * @status no delete
   * @memberof AppAction
   */
  checkForSignRequest = (history) => {
    let { verifiedSignRequest } = this.state;
    let location = this.localStorageService.getLocalStorageItem("url");

    if (location && location !== "" && !verifiedSignRequest) {
      this.setState({ verifiedSignRequest: true });
      let signRequestPath = location.split("#")[1];
      if (signRequestPath !== "/" && signRequestPath !== "/?registered=true")
        history.push(signRequestPath);
    }
  };

  /**
   * @author Juan Manuel Lamperti
   * @description Toggle expanded prop to side menu
   * @updatedDate 30-06-2022
   * @status no delete
   * @memberof AppAction
   */

  toggleExpandedSideMenu = () => {
    this.setState({ expanded: !this.state.expanded });
  };


  /**
   * @description reload the logo functionality
   * @status no delete
   * @memberof AppAction
   */
  reloadLogo = () => {
    this.setState({
      logo: this.localStorageService.getLocalStorageItem("clientLogo")
    })
  }

  /**
 * @description reload the logo functionality
 * @status no delete
 * @memberof AppAction
 */
  reloadProfileImage = () => {
    let userProfilePicture = this.localStorageService.getLocalStorageItem("newImage")
    this.setState({
      userPathImage: userProfilePicture
    })
  }
  /**
   * @author Adrian Montemayor
   * @description Sound ding
   * @updatedDate 30-06-2022
   * @status no delete
   * @memberof AppAction
   */

  playSound = () => {
    let ding = new Audio(Ding);
    if (this.state.soundActive) {
      ding.play();
    }
  };

  changeLanguage = async (language) => {
    await this.userService.updateLanguage(language, this.token)
  }

  /**
   * @author Antonio Vazquez
   * @description event to get user assistants
   * @date 10-11-2025
   */
  handleGetAssistants = async (firstInit = false) => {
    try {
      const token = this.localStorageService.getLocalStorageItem('token', true)?.accessToken
      const clientId = this.localStorageService.getLocalStorageItem('user', true)?.userMetaData?.userA3Cloud.clientId
      const response = await this.userService.getAssistants(clientId, token)
      await this.setState({botConfigList: response})

      if (firstInit && this.props.globalState && typeof this.props.globalState.setBotConfig === 'function') {
        this.props.globalState.setBotConfig(response[0])
      }
    } catch (e) {
      console.error(`An error occurred in event getAssistants:: ${e}`)
    }
  }

  /**
   * @author Antonio Vazquez
   * @description event to get user assistants
   * @date 11-11-2025
   */
  handleCreateNewAssistant = async (chatbotName) => {
    try {
      const token = this.localStorageService.getLocalStorageItem('token', true)?.accessToken
      const clientId = this.localStorageService.getLocalStorageItem('user', true)?.userMetaData?.userA3Cloud.clientId
      this.props.modalUtil.showModal('loading', this.props.t('modal.pure.loading.message'), this.props.t('modal.pure.loading.title'))
      const response = await this.userService.postCreateNewAssistant(clientId, chatbotName, token)
      if (response) {
        this.props.modalUtil.showModal('success', null, this.props.t('modal.pure.title.success'))
        await this.handleGetAssistants()
      }
    } catch (e) {
      this.props.modalUtil.showModal('error', e?.message, this.props.t('modal.pure.title.error'))
      console.error(`An error occurred in event getAssistants:: ${e}`)
    }
  }

  render() {
    const { innerWidth: fullWidth, innerHeight: fullHeight } = window;
    if (this.state.loading) {
      return <div className="loading">
        <SimpleLoading />
      </div>
    } else {
      return (
        <SocketContext.Provider value={socket}>
          <MuiThemeProvider theme={theme}>
            <ContextProvider
              visibleDialogTimerSignOff={this.state.visibleDialogTimerSignOff}
              logo={this.state.logo}
              setShowError={(showError) => this.setState({ showError })}
              drawerItems={this.state.itemsReceived}
            >
              {({
                showSignatureCanvas,
                showPdf,
                pdf,
                setShowPdf,
                pdfSucess,
                setPdfSucess
              }) => (
                <React.Fragment>
                  <div
                    className="main"
                    style={
                      showSignatureCanvas || showPdf ? { display: "none" } : {}
                    }
                  >
                    <Router>
                      <div className="app-menu">
                        <div
                          id="hamburger-icon"
                          className="app-menu-item-accordion-button"
                        >
                          <button
                            className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                            onClick={this.toggleExpandedSideMenu}
                          >
                            <span className="k-icon k-i-menu" />
                          </button>
                        </div>
                        <div className="app-menu-item">
                          <Link
                            to={
                              this.state.contract.data.contractsStatus ===
                                Number(
                                  process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING
                                )
                                ? "/waiting-authorization"
                                : "/"
                            }
                          >
                            <img
                              alt="Logo de Atix"
                              src={LogoeTicketHorizontal}
                              style={{ height: "32px" }}
                            />
                          </Link>
                        </div>
                        <div className="app-menu-item">
                          {/* <div className="app-menu-item-container">
                            <div className="app-menu-item-container-item"></div>
                            <div className="app-menu-item-container-item" style={{ padding: '5px' }}>
                              {clientLogo && (
                                <img
                                  style={{
                                    height: "100%",
                                    marginLeft: "25px",
                                    maxWidth: "150px",
                                  }}
                                  src={clientLogo}
                                  alt="logo"
                                />
                              )}
                            </div>
                            <div className="app-menu-item-container-item"></div>
                          </div> */}
                        </div>
                        <div className="app-menu-item"></div>
                      </div>
                      <div className="div-con-fondo">
                        <AppView
                          {...this.state}
                          items={this.state.itemsReceived}
                          drawerProps={this.drawerProps}
                          handleButtonLogOut={this.handleButtonLogOut}
                          handleClick={this.handleClick}
                          onSelect={this.onSelect}
                          setSelectedItem={this.setSelectedItem}
                          toggleLoadingRequesting={this.toggleLoadingRequesting}
                          toggleCompletedRequesting={
                            this.toggleCompletedRequesting
                          }
                          toggleErrorRequesting={this.toggleErrorRequesting}
                          checkForAuthorization={this.checkForAuthorization}
                          checkForSignRequest={this.checkForSignRequest}
                          toggleDialogTimerSignOff={this.toggleDialogTimerSignOff}
                          onSignOffByTimerEnd={this.onSignOffByTimerEnd}
                          onSignOffByUser={this.onSignOffByUser}
                          onRefreshUserToken={this.onRefreshUserToken}
                          toggleHelpSection={this.toggleHelpSection}
                          toggleNotification={this.toggleNotification}
                          toggleProfileSlideBar={this.toggleProfileSlideBar}
                          toggleSettingSlideBar={this.toggleSettingSlideBar}
                          toggleProfile={this.toggleProfile}
                          playSound={this.playSound}
                          toggleSoundActive={this.toggleSoundActive}
                          onUpdateSocket={this.onUpdateSocket}
                          toggleExpandedSideMenu={this.toggleExpandedSideMenu}
                          changeLanguage={this.changeLanguage}
                          handleGetAssistants={this.handleGetAssistants}
                          handleCreateNewAssistant={this.handleCreateNewAssistant}
                          botConfigList={this.state.botConfigList}
                        >
                          <Routes
                            showError={this.state.showError} // causes error upon login (don't know reason currently)
                            setShowError={(showError) =>
                              this.setState({ showError })
                            }
                            onInvitedRedirectRegister={
                              this.props.onInvitedRedirectRegister
                            }
                            reloadLogo={this.reloadLogo}
                            reloadProfileImage={this.reloadProfileImage}
                          />
                        </AppView>
                      </div>
                      {/* Footer of the page */}
                      <SimpleFooterPure />
                    </Router>
                  </div>

                  <DialogCategory />

                  {showPdf && (
                    <DeviceOrientation lockOrientation={"landscape"}>
                      <Orientation orientation="portrait">
                        <div style={{ width: fullWidth, height: fullHeight }}>
                          <PdfFullScreen
                            pdfSucess={pdfSucess}
                            setPdfSucess={setPdfSucess}
                            pdf={pdf}
                            setShowPdf={setShowPdf}
                            visibleDialogTimerSignOff={
                              this.state.visibleDialogTimerSignOff
                            }
                          >
                            <SimpleLoading />
                          </PdfFullScreen>
                        </div>
                      </Orientation>
                    </DeviceOrientation>
                  )}
                </React.Fragment>
              )}
            </ContextProvider>
          </MuiThemeProvider>
        </SocketContext.Provider>
      );
    }
  }
}


/**
 * @description Container for the app action component
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function AppActionContainer(props) {
  const { t } = useTranslation();
  const globalState = useGlobalState()
  const modalUtil = new ModalUtil()
  return <AppAction {...props} t={t} globalState={globalState} modalUtil={modalUtil} />;
}

export { AppActionContainer as default };
